import type { Profile } from '../../hooks/useOrderQuery';

interface CustomerInfoProps {
  profile: Profile;
  className?: string;
}

export default function CustomerInfo({ profile, className = '' }: CustomerInfoProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <div>
        <p className="text-xs text-nb-text-muted uppercase tracking-wide">Customer</p>
        <p className="font-medium text-black">{profile.full_name || 'N/A'}</p>
      </div>

      {profile.phone && (
        <div>
          <p className="text-xs text-nb-text-muted uppercase tracking-wide">Phone</p>
          <a
            href={`tel:${profile.phone}`}
            className="text-black hover:text-nb-yellow hover:underline"
          >
            {profile.phone}
          </a>
        </div>
      )}

      {profile.email && (
        <div>
          <p className="text-xs text-nb-text-muted uppercase tracking-wide">Email</p>
          <a
            href={`mailto:${profile.email}`}
            className="text-black hover:text-nb-yellow hover:underline"
          >
            {profile.email}
          </a>
        </div>
      )}
    </div>
  );
}